import { ROUTES } from 'global/constants';
import * as React from 'react';
import { Link } from 'react-router-dom';

import { StandardPageLayout } from 'ui/components/StandardPageLayout';
import { WrappedMessage } from 'utils';
import messages from '../displayMessages';
import { intl } from 'i18n';

class SignupDeniedAge extends React.PureComponent {
    public render() {
        return (
            <div className='signup-denied signup-denied-age'>
                <div className='logo'></div>
                <h1><WrappedMessage message={messages.timeToExploreTitle}/></h1>
                <div><WrappedMessage message={messages.timeToExploreDescription}/></div>
                <Link
                    className='btn btn-warning'
                    to={ROUTES.Explore.HOME}
                    aria-label={intl.formatMessage(messages.checkItOutButtonLabel)}>
                    <WrappedMessage message={messages.checkItOutButtonLabel}/>
                </Link>
            </div>
        );
    }
}

class SignupDeniedEmbargo extends React.PureComponent {
    public render() {
        return (
            <div className='signup-denied signup-denied-embargo'>
                <div className='logo'></div>
                <h1><WrappedMessage message={messages.embargoCantRegisterTitle}/></h1>
                <div><WrappedMessage message={messages.embargoCantRegisterDescription}/></div>
            </div>
        );
    }
}

class SignupDeniedSDN extends React.PureComponent {
    public render() {
        const mailtoLink = <a href='mailto:ofac.reconsideration@treasury.gov'>ofac.reconsideration@treasury.gov</a>;

        return (
            <div className='signup-denied signup-denied-sdn'>
                <div className='logo'></div>
                <h1><WrappedMessage message={messages.sdnCantRegisterTitle}/></h1>
                <div>
                    <WrappedMessage message={messages.sdnCantRegisterDescription} values={{mailtoLink}} />
                </div>
            </div>
        );
    }
}

export enum SignupDeniedReason {
    AGE = 0,
    EMBARGO,
    SDN,
}

interface Props {
    reason: SignupDeniedReason;
}

export class SignupDenied extends React.PureComponent<Props> {

    public render() {
        return (<StandardPageLayout>{this.getComponent()}</StandardPageLayout>);
    }

    private getComponent() {
        switch (this.props.reason) {
            case SignupDeniedReason.AGE:
                return <SignupDeniedAge />;
            case SignupDeniedReason.EMBARGO:
                return <SignupDeniedEmbargo />;
            case SignupDeniedReason.SDN:
                return <SignupDeniedSDN />;
        }
    }

}
